// Version : 1.0.0
// Author : AGALYA

import NocPhotosActionType from './noc-photos.types';

/** ***************** update Noc Photos Start ************************/
export const updateNocPhotosStart = (housePhotosCredentials: any) => ({
	type: NocPhotosActionType.UPDATE_NOC_PHOTOS_START,
	payload: housePhotosCredentials,
});

export const updateNocPhotosSuccess = (housePhotosSuccess: any) => ({
	type: NocPhotosActionType.UPDATE_NOC_PHOTOS_SUCCESS,
	payload: housePhotosSuccess,
});

export const updateNocPhotosFailure = (housePhotosFailure: unknown) => ({
	type: NocPhotosActionType.UPDATE_NOC_PHOTOS_FAILURE,
	payload: housePhotosFailure,
});

export const updateNocPhotosResponseResetStart = () => ({
	type: NocPhotosActionType.UPDATE_NOC_PHOTOS_RESPONSE_REST_START,
});

export const updateNocPhotosResponseChanged = () => ({
	type: NocPhotosActionType.UPDATE_NOC_PHOTOS_RESPONSE_CHANGED,
});
/** ***************** update Noc Photos End ************************/
